import tw from 'tailwind-styled-components'
import styled from 'styled-components'
import { getLayerColor } from '../../utils'

export const LayerIdentifier = styled(tw.div`
  w-4
  h-4
  bg-opacity-40
  border
  rounded
`)<{ $id: string }>`
  background-color: ${({ $id }) => getLayerColor($id)}50;
  border-color: ${({ $id }) => getLayerColor($id)};
`
